import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import MaterialKit from "./plugins/material-kit";
import i18n from "./i18n";
import { getEnglishOnlyRedirect, resolveLocale } from "./utils/locale-routing";

import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";
import { isMobile } from "mobile-device-detect";

Vue.config.productionTip = false;

Vue.prototype.$isMobile = isMobile;

router.beforeEach((to, from, next) => {
  const englishOnlyRedirect = getEnglishOnlyRedirect(to);
  if (englishOnlyRedirect) {
    next(englishOnlyRedirect);
    return;
  }

  const language = resolveLocale(to);
  i18n.locale = language;

  if (to.matched.some(view => view.meta.requiresAuth)) {
    if (
      window.localStorage.getItem("password") !==
      "819e3d6c1381eac87c17617e5165f38c"
    ) {
      next({
        name: "protected",
        params: { lang: language },
        query: { previousRouter: to.name }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

var option = {
  bgOpacity: 0.9
};
Vue.use(preview, option);
Vue.use(MaterialKit);

const NavbarStore = {
  showNavbar: false
};

Vue.mixin({
  data() {
    return {
      NavbarStore
    };
  }
});

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
